import React from 'react'

export default function OurStory() {
    return (
        <>
            <section class="page-title-center-alignment cover-background top-space-padding" style={{ backgroundImage: `url(images/about-title-bg.jpg)` }}>

                <div class="container">

                    <div class="row">

                        <div class="col-12 text-center position-relative page-title-extra-large">

                            <h1 class="alt-font d-inline-block fw-700 ls-minus-05px text-base-color mb-10px mt-3 md-mt-50px">About us</h1>

                        </div>

                        <div class="col-12 breadcrumb breadcrumb-style-01 d-flex justify-content-center">

                            <ul>

                                <li><a href="index.php">Home</a></li>

                                <li>Our Story</li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>
            {/* <!-- start section --> */}

            <section class="pb-3 position-relative overflow-hidden">

                <div class="container">

                    <div class="row mb-4 align-items-center text-center text-sm-start">

                        <div class="col-lg-2 col-md-3 col-sm-4 xs-mb-20px" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <div class="position-relative d-md-flex flex-column align-items-center justify-content-center w-165px h-165px border-radius-100">

                                <img src="images/thumb.png" class="position-absolute top-50 translate-middle-y" alt="" />

                                <img src={require('../assets/images/about-02.png')} class="animation-rotation" alt="" />

                            </div>

                        </div>

                        <div class="col-lg-5 col-md-7 col-sm-8" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <span class="text-uppercase fs-13 ls-2px fw-600 mb-5px d-block">Apollo Overseas story</span>

                            <h3 class="text-dark-gray alt-font fw-700 mb-0">Commitment to quality product.</h3>

                        </div>

                        <div class="col-lg-5 md-mt-30px last-paragraph-no-margin" data-anime='{ "translateX": [0, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                            <p>Your home - a tapestry woven with life's precious moments, big and small. At Apollo Overseas, we believe in crafting handloom bedding and bath products that become integral threads in your story, designed not just for style, but for every lifestyle and every dream.</p>

                        </div>

                    </div>

                </div>

                <div class="container-fluid">

                    <div class="row align-items-center">

                        <div class="col-md-3 text-center p-4 md-p-15px" data-bottom-top="transform: translateY(-80px)" data-top-bottom="transform: translateY(80px)">

                            <img class="w-100" src="images/about-img-02.jpg" alt="" />

                        </div>

                        <div class="col-md-6 text-center" data-bottom-top="transform: translateY(80px)" data-top-bottom="transform: translateY(-80px)">

                            <img class="w-100" src="images/about-img-01.jpg" alt="" />

                        </div>

                        <div class="col-md-3 text-center p-4 md-p-15px" data-bottom-top="transform: translateY(-80px)" data-top-bottom="transform: translateY(80px)">

                            <img class="w-100" src="images/about-img-03.jpg" alt="" />

                        </div>

                    </div>

                </div>

                {/* <!-- start marquees --> */}

                <div class="marquees-text alt-font fw-700 fs-200 lg-fs-150 md-fs-130 ls-minus-5px text-base-color text-nowrap position-absolute top-50 lg-mt-5 md-mt-15 sm-mt-22 right-100px text-center z-index-minus-1 d-none d-md-inline-block">Apollo Overseas</div>

                {/* <!-- end marquees --> */}

            </section>

            {/* <!-- end section --> */}

            {/* <!-- start section --> */}

            <section class="pt-0">

                <div class="container">

                    <div class="row justify-content-center mb-40px sm-mb-30px">

                        <div class="col-lg-5 text-center" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>



                            <h4 class="alt-font text-dark-gray fw-700 mb-20px">Our Commitments</h4>

                            <span class="text-uppercase fs-13 ls-2px fw-600">More than just exquisite designs and unparalleled quality we embody a commitment to</span>

                        </div>

                    </div>

                    <div class="row row-cols-auto row-cols-xl-3 row-cols-sm-2 lg-ps-10 lg-pe-10 md-ps-7 md-pe-7 sm-ps-0 sm-pe-0 position-relative mb-6 md-mb-8 lg-mt-20px" data-anime='{ "el": "childs", "translateX": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-start xs-mb-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">01</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Preserving time honored artistry</span>

                                    <p> Each piece whispers a story, an heirloom passed down through generations, where skilled hands breathe life into every thread.</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-end mt-30px lg-mt-0">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">02</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Ethical sourcing and fair trade practicese</span>

                                    <p>We ensure both weavers and consumers receive their just reward, fostering a spirit of shared prosperity</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-start lg-mt-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">03</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Eco-conscious materials and responsible </span>

                                    <p>From seed to stitch, we strive to minimize our environmental footprint, respecting the land that nourishes our craft.</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                        {/* <!-- start features box item --> */}

                        <div class="col align-self-end lg-mt-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">04</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Curated collections and bespoke creations</span>

                                    <p> Whether seeking timeless classics or modern expressions, explore our diverse offerings, or collaborate with us to craft unique designs that capture your brand's essence</p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>


                        {/* ----------------------------add section------------------------------------------------------- */}

                        <div class="col align-self-end lg-mt-30px">

                            <div class="feature-box text-start ps-30px pe-30px sm-ps-20px sm-pe-20px">

                                <div class="feature-box-icon position-absolute left-0px top-0px">

                                    <h1 class="alt-font fs-90 text-outline text-outline-width-1px text-outline-color-dark-gray fw-800 ls-minus-1px opacity-2 mb-0">05</h1>

                                </div>

                                <div class="feature-box-content last-paragraph-no-margin pt-30 lg-pt-22 xs-pt-40px">

                                    <span class="text-dark-gray fs-18 d-inline-block fw-600 mb-5px">Unwavering dedication to service</span>

                                    <p>We go the extra mile to understand your needs and exceed your expectations, ensuring a journey as smooth as the finest silk.
                                    </p>

                                    <span class="w-60px h-2px bg-dark-gray mt-20px d-inline-block"></span>

                                </div>

                            </div>

                        </div>

                        {/* <!-- end features box item --> */}

                    </div>

                    <div class="row justify-content-center xs-mt-12" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                        <div class="col-xl-9 col-lg-10">

                            <div class="row align-items-center justify-content-center border border-color-extra-medium-gray border-radius-100px sm-border-radius-6px sm-mx-0">

                                <div class="col-md-6 p-20px border-end border-color-transparent-dark-very-light text-center ls-minus-05px align-items-center d-flex justify-content-center sm-border-end-0 sm-pb-0 sm-mb-10px">

                                    <i class="bi bi-emoji-smile text-dark-gray icon-extra-medium me-10px"></i>

                                    <span class="text-dark-gray fs-18 text-start fw-500 xs-lh-28"><span class="fw-800">10000+</span> people trusting us.</span>

                                </div>

                                <div class="col-md-6 p-20px sm-pt-0 text-center ls-minus-05px align-items-center d-flex justify-content-center">

                                    <i class="bi bi-star text-dark-gray icon-extra-medium me-10px"></i>

                                    <span class="text-dark-gray fs-18 text-start fw-500">4.9 out of 5 - <span class="fw-800">8549</span> Total reviews.</span>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>


            <section class="pb-3 bg-gradient-very-light-gray lg-pb-40px md-pb-20px">

                <div class="container">



                    <div class="row">

                        <div class="col-12">

                            <ul class="blog-classic blog-wrapper grid-loading grid grid-4col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large" data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay":100, "staggervalue": 150, "easing": "easeOutQuad" }'>

                                <li class="grid-sizer"></li>

                                {/* <!-- start blog item --> */}

                                <li class="grid-item grid-item-double">

                                    <div class="card bg-transparent border-0 h-100">

                                        <div class="blog-image position-relative overflow-hidden border-radius-4px">

                                            <a href="#"><img src="images/mission.jpg" alt="" /></a>

                                        </div>

                                        {/* <div class="card-body px-0 pt-30px pb-30px xs-pb-15px">

                                            <span class="fs-13 text-uppercase d-block mb-5px fw-500"><a href="#" class="text-dark-gray fw-700 categories-text">Mission & Philosophy</a></span>

                                            <p>We understand that a home is more than the sum of its parts. It's about comfort, warmth, and peace - essential elements that nourish the soul. That's why we're committed to ethical sourcing and sustainable practices, ensuring each handloom piece contributes to a better world.

                                                <br />

                                                Generations of skilled artisans weave their stories into our textiles, creating unique pieces that whisper of heritage and timeless beauty. Our diverse collections offer something for every dream, from classic comfort to modern expressions.</p>



                                        </div> */}

                                    </div>

                                </li>

                                {/* <!-- end blog item --> */}

                                {/* <!-- start blog item --> */}

                                <li class="grid-item grid-item-double">

                                    <div class="card bg-transparent border-0 h-100">

                                        <div class="blog-image position-relative overflow-hidden border-radius-4px">

                                            <a href="#"><img src="images/Philosophy.jpg" alt="" /></a>

                                        </div>

                                        {/* <div class="card-body px-0 pt-30px pb-30px xs-pb-15px">

                                            <span class="fs-13 text-uppercase d-block mb-5px fw-500"><a href="#" class="text-dark-gray fw-700 categories-text">Philosophy</a></span>

                                            <p>

                                                And for those with unique aspirations, we offer bespoke creations, allowing you to bring your vision to life. It's not just about what you choose, but about the meaning and story that resonates with you.

                                                <br /><br />

                                                Join us on this journey of weaving tradition and comfort into your home. Discover the strength and beauty of handlooms with Apollo Overseas, and experience the difference ethical luxury and conscious living can make.</p>

                                        </div> */}

                                    </div>

                                </li>

                                {/* <!-- end blog item --> */}



                            </ul>
                        </div>


                        {/* -------------------------------------------add mision -------------------------------------- */}
                        <div className='col-12 text-center mt-4 fs-2 fw-bolder text-black'>
                            <span>Mission & Philosophy</span>
                        </div>


                        <div>



                            <p className='mt-3'>We understand that a home is more than the sum of its parts. It's about comfort, warmth, and peace - essential elements that nourish the soul. That's why we're committed to ethical sourcing and sustainable practices, ensuring each handloom piece contributes to a better world.
                                Generations of skilled artisans weave their stories into our textiles, creating unique pieces that whisper of heritage and timeless beauty. Our diverse collections offer something for every dream, from classic comfort to modern expressions.
                                And for those with unique aspirations, we offer bespoke creations, allowing you to bring your vision to life. It's not just about what you choose, but about the meaning and story that resonates with you.
                                Join us on this journey of weaving tradition and comfort into your home. Discover the strength and beauty of handlooms with Apollo Overseas, and experience the difference ethical luxury and conscious living can make.
                            </p>

                        </div>

                    </div>

                </div>



            </section>

            {/* <!-- end section --> */}
        </>
    )
}
